import getCoverPhotoStoragePath from "utils/firebase/storage-paths/getCoverPhotoStoragePath";
import uploadFile from "utils/firebase/uploadFile";

/**
 * Uploads cover photo to Firebase storage.
 *
 * @param userId the user to upload for.
 * @param file the file to upload.
 * @return the download URL
 */
export default async function uploadCoverPhoto(
  userId: string,
  file: File
): Promise<string> {
  const path = getCoverPhotoStoragePath(userId);

  return uploadFile(file, path);
}
